import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AuthData } from '@tesla/ng-auth';
import { BehaviorSubject, Observable } from 'rxjs';
import { Language, TranslateLanguage } from '../../profile/models/supplier.model';
import { MasterDataService } from '../../profile/services/masterdata.service';
import { LocalStorageService } from '../../shared/services/index.service';
//import { Language } from "../models/language.model";

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly languageRegex = /[a-z]{2}-[A-Z]{2}/g;
  private selectedLangID: string;
  private languages: Language[] = [];
  private selectedLangID$: BehaviorSubject<string> = new BehaviorSubject('en-US');
  private translateLangues: TranslateLanguage[] = [
    {
        "name": "Chinese - 简体中文",
        "id": "zh-CN"
    },
    {
        "name": "Czech - čeština",
        "id": "cs-CZ"
    },
    {
        "name": "Danish - dansk",
        "id": "da-DK"
    },
    {
        "name": "English",
        "id": "en-US"
    },
    {
        "name": "Finnish - suomi",
        "id": "fi-FI"
    },
    {
        "name": "French - Français",
        "id": "fr-FR"
    },
    {
        "name": "German - Deutsch",
        "id": "de-DE"
    },
    {
        "name": "HK Chinese - 繁體中文（香港）",
        "id": "zh-HK"
    },
    {
        "name": "Hungarian - magyar",
        "id": "hu-HU"
    },
    {
        "name": "Icelandic - íslensku",
        "id": "is-IS"
    },
    {
        "name": "Italian - Italiano",
        "id": "it-IT"
    },
    {
        "name": "Japanese - 日本語",
        "id": "ja-JP"
    },
    {
        "name": "Korean - 한국어",
        "id": "ko-KR"
    },
    {
        "name": "Norwegian - norsk",
        "id": "no-NO"
    },
    {
        "name": "Polish - polski",
        "id": "pl-PL"
    },
    {
        "name": "Spanish (Spain) - Español (España)",
        "id": "es-ES"
    },
    {
        "name": "Spanish (Mexico) - Español (México)",
        "id": "es-MX"
    },
    {
        "name": "Swedish - svenska",
        "id": "sv-SE"
    },
    {
      "name": "Turkish - Türkçe",
      "id": "tr-TR"
    },
    {
        "name": "TW Chinese - 繁體中文（台灣）",
        "id": "zh-TW"
    }
  ];

  constructor(
    private storage: LocalStorageService,
    private masterDataService: MasterDataService,
    private authData: AuthData,
    private transloco: TranslocoService,
  ) {
    if (this.authData.isTokenActive())
      this.masterDataService.getLanguages().subscribe((langs) => (this.languages = langs));
  }

  changeLanguage(langID: string) {
    localStorage.setItem('Profile-Culture', langID);
    localStorage.setItem('ttp-locale', langID);
    this.selectedLangID$.next(langID);
    if (window.location.href.includes('tasks')) {
      this.transloco.setActiveLang(langID);
    } else {
      const base = `${window.location.protocol}//${window.location.hostname}/profile`;
      const path = window.location.pathname.split('/').slice(3).join('/');
      let params = window.location.href.split('?').slice(1)[0];
      params = params ? `?${params}` : '';
      let href = `${base}/`;

      if (path !== 'auth/callback') {
        href += `${path}${params}`;
      }
      this.transloco.setActiveLang(langID);
      this.selectedLangID = langID;
    }
  }

  getSelectedLanguage(): string {
    return this.selectedLangID || this.languages?.[0]?.id;
  }

  getSelectedLanguageAsync(): Observable<string> {
    return this.selectedLangID$.asObservable();
  }

  getLanguages(): Language[] {
    return this.languages;
  }

  setUseProdEnv(useProdEnv: boolean): void {
    localStorage.setItem('use-prod-env', String(useProdEnv));
    location.reload();
  }

  getTranslateLangues(): TranslateLanguage[] {
    return this.translateLangues;
}
}
